/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "../../../auth";
import { getPaymentStatus, updatePlanRenewal } from "../core/_requests";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
   const { currentUser } = useAuth();
   const localId = localStorage.getItem("chefId");
 console.log("Local Stored Chef ID:", localId);
   const chefId =localId || currentUser?.uuid;
const isUrlchef = localStorage.getItem("params");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPlanRenewal, setIsPlanRenewal] = useState<null | boolean>(null);
  const [result, setResult] = useState<{ message: string; status: boolean } | null>(null);

  const [sessionId, setSessionId] = useState(localStorage.getItem("stripeSessionId"));
  const [subscribedPlanId] = useState(localStorage.getItem("subscribedPlanId"));

  const naviagte = useNavigate();
  

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const sessionIdFromUrl = urlParams.get("session_id");
    if (sessionIdFromUrl && !sessionId) {
      
      setSessionId(sessionIdFromUrl);
      localStorage.setItem("stripeSessionId", sessionIdFromUrl);
    }
  }, [location, sessionId]);

 const checkPaymentStatus = async () => {
  if (!sessionId || !subscribedPlanId) return;

  try {
    const res = await getPaymentStatus(sessionId, subscribedPlanId);

    setResult(res);

    if (res.status) {
      toast.success("Plan activated successfully!", { autoClose: 3000 });
      setIsModalOpen(true);

      // cleanup
      localStorage.removeItem("stripeSessionId");
      localStorage.removeItem("subscribedPlanId");
    }
  } catch (error) {
    console.error("Error checking payment status:", error);
  }
};

 useEffect(() => {
  if (!sessionId || !subscribedPlanId) return;

  const interval = setInterval(async () => {
    const res = await getPaymentStatus(sessionId, subscribedPlanId);

    setResult(res);

    if (res.status) {
      toast.success("Plan activated successfully!", { autoClose: 3000 });
      setIsModalOpen(true);
      clearInterval(interval);

      localStorage.removeItem("stripeSessionId");
      localStorage.removeItem("subscribedPlanId");
    }
  }, 3000); // ⏱ poll every 3s

  return () => clearInterval(interval);
}, [sessionId, subscribedPlanId]);

  useEffect(() => {
    const alreadyChecked = localStorage.getItem("hasCheckedPayment");
    if (!alreadyChecked && sessionId) {
      checkPaymentStatus();
      localStorage.setItem("hasCheckedPayment", "true");
    }

    return () => {
      localStorage.removeItem("hasCheckedPayment");
    };
  }, [sessionId, subscribedPlanId]);

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (isPlanRenewal === null) {
      toast.error("Please select an option before submitting.");
      return;
    }

    try {
      const payload = { chefId, planId: subscribedPlanId, isPlanRenewal };
      const res = await updatePlanRenewal(payload);

      if (res.status) {
        toast.success(res.message || "Auto-renewal updated successfully!", { autoClose: 4000 });
        localStorage.removeItem("stripeSessionId");
        localStorage.removeItem("subscribedActivePlanId");
        navigate("/subscription");
      } else {
        toast.error(res.message || "Failed to update auto-renewal", { autoClose: 4000 });
      }
    } catch (error) {
      console.error("Error updating auto-renewal:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsModalOpen(false);
    }
  };
const handleBack = (isUrlchef : any)=>{
  if(isUrlchef === 1){
    window.close()

  }
  else{
    naviagte("/dashboard");
    window.location.reload()
  }

}

  return (
    <section className="container-fluid">
      <div className="overlay"></div>
      <div className="drawer small add-dish">
        <div className="alert-wrap text-center">
          <img
            className="ico mb-4"
            src="/assets/images/alert-success-ico.svg"
            alt="success"
          />
          <h1 className="mb-4">Awesome!</h1>
          <p className="mid-gray mb-2">
            <small>{result?.message || "Your payment was successful!"}</small>
          </p>
        <button
  className="btn btn-cancel rounded-5"
  onClick={handleBack  }
>
  Back to Home
</button>
        </div>
      </div>

      {/* Auto-Renewal Modal */}
      {result?.status && (
        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} centered>
          <div className="modal-content container-fluid">
            <Modal.Title className="mx-auto modal-header text-center w-100">
              <span role="img" aria-label="alert" className="text-warning" style={{ fontSize: "2rem" }}>
                ⚠️
              </span>
              <span className="text-danger ms-2" style={{ fontSize: "16px" }}>
                {result?.message}
              </span>
            </Modal.Title>

            <div className="modal-body">
              <div className="text-center mb-3">
                <p>Do you want to enable auto-renewal of the plan?</p>
              </div>

              <form
                onSubmit={handleFormSubmit}
                noValidate
                onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              >
                <div className="d-flex justify-content-center mb-4">
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="autoRenewYes"
                      onChange={() => setIsPlanRenewal(true)}
                    />
                    <label className="form-check-label text-success" htmlFor="autoRenewYes">
                      Yes
                    </label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="autoRenewNo"
                      onChange={() => setIsPlanRenewal(false)}
                    />
                    <label className="form-check-label text-danger" htmlFor="autoRenewNo">
                      No
                    </label>
                  </div>
                </div>

                <div className="modal-footer d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-cancel rounded-5 px-5 mt-2 mb-2"
                    onClick={() => setIsModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary rounded-5 px-5 mt-2 mb-2"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      )}
    </section>
  );
};

export default PaymentSuccess;